// removed by extract-text-webpack-plugin
module.exports = {"icon":"G45d3ee"};